import type { Store } from 'vuex';

/** Clears persisted cart lines after a successful cart checkout (all line types). */
export function clearCartAfterSuccessfulCheckout(store: Store<unknown>): void {
  store.dispatch('cart/clearCart');
}

export function isPostCartCheckoutRedirect(redirect: string | null | undefined): boolean {
  if (!redirect) return false;
  return redirect.includes('/web/ticket/success');
}
